import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';
import { IBiddingPagedRequest } from '../../../../model/apm/bidding/request/bidding-paged-request';
import { IBiddingAddEditRequest } from '../../../../model/apm/bidding/request/bidding-add-edit-request';
import { IBiddingListResponse } from '../../../../model/apm/bidding/response/bidding-list-response';
import { IBiddingResponse } from '../../../../model/apm/bidding/response/bidding-response';

const defaultPath = 'Bidding';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IBiddingPagedRequest): Promise<Pagination<IBiddingListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            ModalityId: params.modalityId,
            Status: params.status,
            Year: params.year,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IBiddingListResponse>(), response.data));
};

const listModalities = async (): Promise<ILookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Modality`
    }).then((response) => response.data || []);
};

const listManagementUnits = async (): Promise<ILookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ManagementUnit`
    }).then((response) => response.data || []);
};

const getById = async (id: number): Promise<IBiddingResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IBiddingAddEditRequest): Promise<IBiddingResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IBiddingAddEditRequest): Promise<IBiddingResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const listDocumentTypes = async (): Promise<ILookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentType`
    }).then((response) => response.data || []);
};

// O Content-Type multipart (com boundary) é definido pelo axios a partir do FormData
const uploadFile = async (id: number, documentTypeId: number, file: File, onProgress?: (percent: number) => void): Promise<IPortalDocumentResponse> => {
    const formData = new FormData();
    formData.append('DocumentTypeId', String(documentTypeId));
    formData.append('File', file);

    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/File`,
        data: formData,
        onUploadProgress: (event) => {
            if (onProgress && event.total) {
                onProgress(Math.round((event.loaded * 100) / event.total));
            }
        }
    }).then((response) => response.data);
};

const removeFile = async (id: number, fileId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/File/${fileId}`
    });
};

const BiddingAppService = {
    list, getById, add, edit, remove,
    listModalities, listManagementUnits, listDocumentTypes, uploadFile, removeFile
};
export default BiddingAppService;
